import { default as CE_TrackedUser } from "ce/utils/Analytics/trackedUser";

class TrackedUser extends CE_TrackedUser {
  protected getUserSource(): string {
    return this.selfHosted ? "ee" : "cloud";
  }
}

export default TrackedUser;
